import { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'

import { withStore } from '@bigyellow/store'
import { requiresAuth } from '@bigyellow/libs/auth'
import { customer_accounts__get, store__get } from '@bigyellow/api/customer'
import { setItem } from '@bigyellow/libs/storage'

import AccountLayout from '@bigyellow/components/Layouts/AccountLayout'
import StoreItem from '@bigyellow/components/Store'
import LinkAccount from '@bigyellow/components/SignIn/LinkAccount'
import { setCurrentCustomer } from '@bigyellow/libs/customer'

const IndexPage = ({store ,user}) => {

    const [stores, setStores] = useState([]);
    const [showSignUp, setShowSignUp] = useState(false);

    const http_client = store.get('http_client');

    useEffect(async () => {
        const accounts = await customer_accounts__get(http_client, {userId: user.id});
        user.customerAccounts = accounts.data.data;
        await setCurrentCustomer(user);
        await getStores(user);
    }, [showSignUp]);

    /**
     * Fetch information about store locations
     *
     * @param user
     * @returns {Promise<void>}
     */
    const getStores = async (user) => {
        const promises = [];

        user.customerAccounts.forEach((account) => {
            promises.push(store__get(http_client, {
                storeId: account.storeId
            }));
        });

        Promise.all(promises).then((responses) => {
            const data = responses.map((response) => response.data.data[0]);
            setStores(data)
            setItem('stores', data);
        })
    }

    if (!user || !stores) {
        return <></>
    }

    return (
        <AccountLayout
            parentLink={''}
            parent="My Account"
            title="My Account"
            mainContentAdditionalClassNames={`dashboard full-width`}
        >
            {showSignUp && (
                <>
                    <h2 className={`mt-4`}>
                        Add your storage
                    </h2>
                    <p className={`text-center pt-3 pb-0`}>
                        <small className="text-xs text-muted">
                            Find your account details on your Invoice or reservation email.
                        </small>
                    </p>

                        <LinkAccount
                          store={store}
                          OnComplete={() => {
                                setTimeout(() => {
                                    setShowSignUp(false);
                                    window.location.reload();
                                }, 300)
                            }}
                            OnCancel={() => setShowSignUp(false)}
                        />

                </>
            )}

            {!showSignUp  && user && user.customerAccounts.map((item, key) => (
                <StoreItem
                    account={item}
                    key={key}
                />
            ))}

            {!showSignUp  && (
                <>
                    <div className={`text-center mt-5`}>
                        <p className={`text-center text-muted`}>
                            Don't see your storage here?
                        </p>
                        <Button variant={`link`} className={`text-underline`} onClick={() => setShowSignUp(true)}>
                            Add storage
                        </Button>
                    </div>
                </>
            )}

        </AccountLayout>
    )
}

export default withStore(requiresAuth(IndexPage));
